


























import { ICalendarDoor } from '@/common/interfaces/announcement-bar.interface';
import CalendarCloseButton from '@/components/announcementbar/christmas-calendar/subcomponents/CalendarCloseButton.vue';
import ChristmasCalendarDesktopView from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarDesktopView.vue';
import ChristmasCalendarMobileView from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarMobileView.vue';
import InformationOverlay from '@/components/announcementbar/christmas-calendar/subcomponents/InformationOverlay.vue';
import PartnerShopHelper from '@/helpers/page-specific/PartnerShopHelper';
import SessionStorageHelper from '@/helpers/SessionStorageHelper';
import TIcons from '@/types/TIcons';
import { ErrorCodes } from '@ringana/errors';
import EErrorCodes from '@ringana/errors/lib/enums/error-codes';
import Vue from 'vue';

interface IChristmasCalendarComponent {
  isPartnerShop: boolean;
  overlay: {
    type: `early` | `late` | null;
    visible: boolean;
  };
}

export default Vue.extend({
  name: `ChristmasCalendar`,
  components: {
    CalendarCloseButton,
    ChristmasCalendarDesktopView,
    ChristmasCalendarMobileView,
    InformationOverlay,
  },
  data(): IChristmasCalendarComponent {
    return {
      isPartnerShop: false,
      overlay: {
        type: null,
        visible: false,
      },
    };
  },
  computed: {
    currentDayForMobile(): number {
      return new Date().getDate();
    },
    currentDayIdForMobile(): number {
      return this.doors[this.currentDayForMobile].id;
    },
    logoPath(): string {
      return PartnerShopHelper.isPageInPartnerShop() ? TIcons.ringanaLogoPartner : TIcons.ringanaLogo;
    },
  },
  props: {
    doors: {
      required: true,
      type: Array as () => ICalendarDoor[],
    },
    title: {
      required: true,
      type: String,
    },
    visible: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    window.addEventListener(`keyup`, this.onKeyUp);
    SessionStorageHelper.setChristmasCalendarSeen();
  },
  beforeDestroy(): void {
    window.removeEventListener(`keyup`, this.onKeyUp);
  },
  methods: {
    closeCalendar(): void {
      this.closeOverlay();
      this.$emit(`close:calendar`);
    },
    closeOverlay(): void {
      this.overlay = {
        type: null,
        visible: false,
      };
    },
    onKeyUp(event: KeyboardEvent): void {
      if(event.code === `Escape`) {
        this.closeCalendar();
      }
    },
    async openSelectedBauble(doorId: number): Promise<void> {
      try {
        // TODO WEB-2271 WEB-2272 WEB-2273 remove eslint-disable
        // eslint-disable-next-line @typescript-eslint/no-unused-vars-experimental
        const response = await this.$abApiService.getDoorById(doorId);
        // TODO WEB-2271 WEB-2272 WEB-2273 pass response to components for door types
      } catch (err) {
        const errorCode: ErrorCodes = err?.info?.errorCode;
        if(errorCode) {
          switch(errorCode) {
            case EErrorCodes.ANNOUNCEMENT_CALENDAR_DOOR_TOO_EARLY:
              this.overlay = {
                type: `early`,
                visible: true,
              };
              break;
            case EErrorCodes.ANNOUNCEMENT_CALENDAR_DOOR_TOO_LATE:
              this.overlay = {
                type: `late`,
                visible: true,
              };
              break;
            default:
              throw err;
          }
        } else {
          throw err;
        }
      }
    },
  },
});
